export const TYPE_ID_DOW = 'day_of_week';
export const TYPE_ID_LOS = 'los';
export const TYPE_ID_MOBILE = 'mobile';
export const TYPE_ID_MEALTYPE = 'mealtype';
export const TYPE_ID_CANCELLATION = 'cancellation'; // Dummy type referring to Best Flex, Semi Flex and Non Refundable
export const TYPE_ID_BEST_FLEX = 'best_flex';
export const TYPE_ID_SEMI_FLEX = 'semi_flex';
export const TYPE_ID_NON_REF = 'non_ref';
export const TYPE_ID_LEADTIME = 'leadtime';
export const TYPE_ID_ROOMTYPE = 'roomtype';
export const TYPE_ID_POSITION = 'position'; // Dummy type created in Frontend
export const TYPE_ID_POS = 'pos';
export const TYPE_ID_MEMBERSHIP = 'membership';

export const SUBTYPE_ID_MOBILE_BOOKINGDOTCOM = 'mobile_bookingdotcom';
export const SUBTYPE_ID_MOBILE_EXPEDIA = 'mobile_expedia';
export const SUBTYPE_ID_MOBILE_HOTELSDOTCOM = 'mobile_hotelsdotcom';

export const SUBTYPE_ID_POS_BOOKINGDOTCOM = 'pos_bookingdotcom';
export const SUBTYPE_ID_POS_EXPEDIA = 'pos_expedia';
export const LABEL_BRANDDOTCOM_WEEKEND = 'branddotcom_weekend';

export const SUBTYPE_VALUES_KEY_STRATEGY = 'rsstrategy';
export const SUBTYPE_VALUES_KEY_CANCELLATION_POLICY = 'rscancellationpolicy';
export const SUBTYPE_VALUES_KEY_PATTERN = 'rspattern';

export const SUBTYPE_DELIMITER = '-';

export const TYPE_ID_TO_TRANSLATION_MAPPING = {
  [TYPE_ID_DOW]: 'strategy.block_title.positioning_per_day_of_week',
  [TYPE_ID_LOS]: 'strategy.block_title.length_of_stay',
  [TYPE_ID_MOBILE]: 'strategy.block_title.mobile_rates',
  [TYPE_ID_MEALTYPE]: 'strategy.block_title.mealtypes',
  [TYPE_ID_BEST_FLEX]: 'rates.best_flex',
  [TYPE_ID_SEMI_FLEX]: 'rates.semi_flex',
  [TYPE_ID_NON_REF]: 'rates.nonrefundable',
  [TYPE_ID_LEADTIME]: 'strategy.block_title.leadtime_pattern',
  [TYPE_ID_ROOMTYPE]: 'strategy.block_title.roomtype_pattern',
  [TYPE_ID_POS]: 'general.pos',
  [TYPE_ID_MEMBERSHIP]: 'general.member_rates',
};

export const COLUMN_WIDTH = {
  DEFAULT: 130,
  LARGE: 200,
  FIXED: 250,
  EXTRA_LARGE: 400,
};

export const COLUMN_PROPERTIES = {
  HOTELINFO: 'hotelinfo',
  ROOM_NAME: 'roomName',
  ROOM_ONLY: 'roomOnly',
  CUT_OFF_POLICY: 'cutOffPolicy',
  RATE: 'rate',
  SUPPLEMENT: 'supplement',
  DISCOUNT: 'discount',
  FREQUENCY_WEEKDAY: 'frequencyWeekday',
  FREQUENCY_WEEKEND: 'frequencyWeekend',
};

export const NO_DATA_SUBSORT = {
  NON_COMPUTABLE: -1,
  NOT_OFFERED: -2,
  SOLDOUT: -3,
  MISSING: -4,
};

export const DETAIL_VIEW_TABS = {
  GRAPH: 'graph',
  TABLE: 'table',
};

// Maximum number of POS countries that can be set
export const RS_POS_COUNTRIES = 3;

export const REFERENCE_PERIODS = {
  ONE_WEEK_AGO: -1,
  ONE_MONTH_AGO: -4,
  THREE_MONTHS_AGO: -12,
};

export const LAST_REFERENCE_PERIOD = '1970-01-01';

export const RSTYPES_IN_CANCELLATION_POLICY_SECTION = [
  TYPE_ID_BEST_FLEX,
  TYPE_ID_SEMI_FLEX,
  TYPE_ID_NON_REF,
];

export const COLUMN_CONFIG = {
  HOTELINFO_HEADER: {
    isFixed: 'left',
    hasRightBorder: true,
    width: COLUMN_WIDTH.FIXED,
  },
  HOTELINFO: {
    textAlign: 'left',
    isFixed: 'left',
    hasRightBorder: true,
    minWidth: COLUMN_WIDTH.FIXED,
    maxWidth: COLUMN_WIDTH.FIXED,
  },
};
